import React from 'react';
import toothChart from './tooth_chart.svg';

export default class Toothchart extends React.Component {

    static universalNotation = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17',
        '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32'];
    static fdiNotation = ['18', '17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '28',
        '38', '37', '36', '35', '34', '33', '32', '31', '41', '42', '43', '44', '45', '46', '47', '48'];

    constructor(props) {
        super(props);
        this.objRef = React.createRef();
    }

    static _toothId(e) {
        return parseInt(e.target.parentNode.id.replace(/^tooth-/, ''));
    }

    componentDidMount() {
        this.objRef.current.addEventListener('load', () => {
            this.objDoc = this.objRef.current.contentDocument;

            let toothBorders = this.objDoc.querySelectorAll('.tooth-border');
            for (let b of toothBorders) {
                b.style.fill = 'white';
                b.style.cursor = 'pointer';

                b.addEventListener('click', this._onToothClick.bind(this));
                b.addEventListener('mouseover', this._onToothMouseover.bind(this));
                b.addEventListener('mouseout', this._onToothMouseout.bind(this));
            }

            this.componentDidUpdate();
        });
    }

    componentDidUpdate() {
        if (!this.objDoc) return; // not mounted
        let teeth = this.props.teeth || {};
        for (let toothNo = 1; toothNo <= 32; toothNo++) {
            let tooth = this.objDoc.getElementById(`tooth-${toothNo}`);
            let toothBorder = tooth.querySelector('.tooth-border');

            let options = Object.assign({
                hidden: false,
                fill: 'white',
                stroke: 'black',
                strokeWidth: 10,
                opacity: 1,
                strokeOpacity: 1,
                fillOpacity: 1,
            }, teeth.hasOwnProperty(toothNo) ? teeth[toothNo] : {});

            tooth.style.display = options.hidden ? 'none' : 'block';
            tooth.style.opacity = options.opacity;
            toothBorder.style.fill = options.fill;
            toothBorder.style.stroke = options.stroke;
            toothBorder.style.strokeWidth = options.strokeWidth;
            toothBorder.style.strokeOpacity = options.strokeOpacity;
            toothBorder.style.fillOpacity = options.fillOpacity;

            let toothLabel = this.objDoc.getElementById(`tooth-label-${toothNo}`);
            toothLabel.querySelector('tspan').textContent = this.props.notation === "FDI" ? Toothchart.fdiNotation[toothNo - 1] : Toothchart.universalNotation[toothNo - 1];
        }

        let sextants = this.props.sextants || {};
        for (let sextantNo = 1; sextantNo <= 6; sextantNo++) {
            let sextantBox = this.objDoc.getElementById(`sextant-${sextantNo}-box`);
            let sextantLabel = this.objDoc.getElementById(`sextant-${sextantNo}-label`);
            let sextantTrend = this.objDoc.getElementById(`sextant-${sextantNo}-trend`);
            let sextantBrushTime = this.objDoc.getElementById(`sextant-${sextantNo}-br-time`);

            let options = Object.assign({
                hidden: false,
                label: ' ',
                trend: ' ',
                trendColor: 'black',
                brushTimeHidden: false,
                brushTime: ' '
            }, sextants.hasOwnProperty(sextantNo) ? sextants[sextantNo] : {});

            sextantBox.style.display = options.hidden ? 'none' : 'block';
            let label = String(options.label).substring(0, 4);
            sextantLabel.textContent = label && label !== "NaN%" ? label : "N/A";
            sextantTrend.textContent = '';
            //sextantTrend.textContent = String(options.trend).substring(0, 1);
            sextantBrushTime.querySelector('tspan').textContent = String(options.brushTime).substring(0, 5);
            sextantBrushTime.style.display = options.brushTimeHidden ? 'none' : 'block';
            sextantTrend.style.fill = options.trendColor;
        }
    }

    _onToothClick(e) {
        if (typeof this.props.onToothClick !== 'function') return;

        this.props.onToothClick({
            number: Toothchart._toothId(e)
        });
    }

    _onToothMouseover(e) {
        if (typeof this.props.onToothOver !== 'function') return;

        this.props.onToothOver({
            number: Toothchart._toothId(e)
        });
    }

    _onToothMouseout(e) {
        if (typeof this.props.onToothOut !== 'function') return;

        this.props.onToothOut({
            number: Toothchart._toothId(e)
        });
    }

    render() {
        return (
            <object
                className="toothchart-object"
                ref={this.objRef}
                data={toothChart}
                aria-label="Tooth Chart"
                type="image/svg+xml"/>
        );
    }
}
